/**
 * Validate if the ACS token is the correct length
 * roughly determined by: 500 < token.length < 1000
 * @param acsToken string value
 */
export function validateAcsToken(acsToken: string): string {
  if (acsToken.length > 500 && acsToken.length < 1000) {
    return acsToken;
  } else return "";
}
